import { html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './tufts-image.css.lit';
import { SlotNGController } from '../../controllers/slot-ng-controller';
import tuftsHeadingCssLit from '../tufts-heading/tufts-heading.css.lit';

/**
 * @element tufts-image
 *
 * @slot - The image to be presented.
 * @slot caption - The caption text for the image.
 *
 * @attr image-ratio
 * @attr rounded
 */

@customElement('tufts-image')
export class tuftsImage extends OutlineElement {
  ngSlot = new SlotNGController(this);
  static styles = [componentStyles, tuftsHeadingCssLit];

  @property({ type: String, attribute: 'image-ratio', reflect: true })
  imageRatio = null;

  @property({ type: Boolean, reflect: true, attribute: 'rounded' })
  rounded: Boolean;

  @property({ type: String, attribute: 'max-width', reflect: true })
  maxWidth = null;
  render(): TemplateResult {
    this.style.setProperty('--border-radius', this.rounded ? '12px' : '0');
    this.style.setProperty('--max-width', this.maxWidth);
    this.style.setProperty(
      '--aspect-ratio',
      this.imageRatio ? this.imageRatio : 'auto'
    );
    return html`
      ${this.ngSlot.conditionalNGSlot('title', true, 'lg')}
      ${this.ngSlot.renderInShadow()}
      ${this.ngSlot.conditionalNGSlot('caption')}
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'tufts-image': tuftsImage;
  }
}
